var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductionAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.25H7C6.59 15.25 6.25 15.59 6.25 16C6.25 16.41 6.59 16.75 7 16.75H10C10.41 16.75 10.75 16.41 10.75 16C10.75 15.59 10.41 15.25 10 15.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25H7C6.59 11.25 6.25 11.59 6.25 12C6.25 12.41 6.59 12.75 7 12.75H10C10.41 12.75 10.75 12.41 10.75 12C10.75 11.59 10.41 11.25 10 11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.75C14.41 8.75 14.75 8.41 14.75 8C14.75 7.59 14.41 7.25 14 7.25H11C10.59 7.25 10.25 7.59 10.25 8C10.25 8.41 10.59 8.75 11 8.75H14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.53 18.42L19.18 16.07C20.14 14.61 19.98 12.63 18.7 11.35C18.42 11.07 18.09 10.85 17.75 10.68V5C17.75 3.48 16.52 2.25 15 2.25H7.83C7.1 2.25 6.41 2.54 5.89 3.06L3.06 5.89C2.54 6.41 2.25 7.1 2.25 7.83V19C2.25 20.52 3.48 21.75 5 21.75H17C17.41 21.75 17.75 21.41 17.75 21C17.75 20.59 17.41 20.25 17 20.25H5C4.31 20.25 3.75 19.69 3.75 19V8.75H7C7.96 8.75 8.75 7.96 8.75 7V3.75H15C15.69 3.75 16.25 4.31 16.25 5V10.27C15.22 10.22 14.18 10.57 13.4 11.35C11.94 12.81 11.94 15.19 13.4 16.65C14.13 17.38 15.09 17.75 16.05 17.75C16.77 17.75 17.49 17.54 18.12 17.13L20.47 19.48C20.62 19.63 20.81 19.7 21 19.7C21.19 19.7 21.38 19.63 21.53 19.48C21.82 19.19 21.82 18.71 21.53 18.42ZM7 7.25H3.91C3.97 7.14 4.03 7.03 4.11 6.94L6.94 4.11C7.03 4.02 7.14 3.96 7.25 3.91V7C7.25 7.14 7.14 7.25 7 7.25ZM14.46 15.59C13.58 14.71 13.58 13.29 14.46 12.41C14.9 11.97 15.47 11.75 16.05 11.75C16.63 11.75 17.2 11.97 17.64 12.41C18.52 13.29 18.52 14.71 17.64 15.59C16.76 16.47 15.34 16.47 14.46 15.59Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionAudit);
export default __webpack_public_path__ + "static/media/production-audit.ac7c0065b82d028746222ef6c1c49701.svg";
export { ForwardRef as ReactComponent };